import React, { useEffect, useState } from 'react';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, Label
} from 'recharts';

function HearingLossChart() {
  // Change fetching data to json format
  //const [data, setData] = useState([]);
  const data = [
    { year: 2019, people: 430 },
    { year: 2030, people: 509 },
    { year: 2040, people: 612 },
    { year: 2050, people: 711 },
  ]
  //const [loading, setLoading] = useState(true);
  //const [error, setError] = useState(null);
  //const API_URL = process.env.REACT_APP_API_URL;

  // Hide the useEffect for fetching data from API for now, since we are using static data.
  // useEffect to fetch global hearing loss data from API when component mounts
  // useEffect(() => {
  //   const fetchHearingLossData = async () => {
  //     try {
  //       console.log("process.env", process.env.REACT_APP_API_URL);
  //       console.log('Fetching Hearing Loss data...');

  //       const response = await fetch(`${API_URL}/api/worldwide-hearing-loss/?format=json`, {
  //         method: 'GET',
  //         headers: {
  //           'Accept': 'application/json',
  //           'Content-Type': 'application/json',
  //         },
  //         mode: 'cors',
  //       });

  //       if (!response.ok) {
  //         throw new Error(`HTTP error! Status: ${response.status}`);
  //       }

  //       const result = await response.json();
  //       console.log('Raw Data:', result);

  //       // Transform the data into the shape your chart expects
  //       const mappedData = result.map(item => ({
  //         year: item.year,
  //         people: item.count_millions,
  //       }));

  //       console.log('Mapped Data:', mappedData);
  //       setData(mappedData);
  //       setLoading(false);
  //     } catch (err) {
  //       console.error('Detailed error:', err);
  //       setError(`Error: ${err.message}. Please check the console for more details.`);
  //       setLoading(false);
  //     }
  //   };

  //   fetchHearingLossData();
  // }, []);

  // Show loading or error message if needed
  // if (loading) return <p>Loading hearing loss chart...</p>;
  // if (error) return <p>{error}</p>;

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={data}
        margin={{ top: 20, right: 30, left: 60, bottom: 40 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="year">
          <Label value="Year" position="bottom" offset={10} />
        </XAxis>
        <YAxis>
          <Label
            value="Number of people (millions)"
            angle={-90}
            position="insideLeft"
            offset={-5}
            style={{ textAnchor: 'middle' }}
          />
        </YAxis>
        <Tooltip formatter={(value) => [`${value} million`, 'People']} />
        <Bar
          dataKey="people"
          fill="#89c8b7"
          radius={[8, 8, 0, 0]}
          activeBar={{ fill: '#d4f1e5' }}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}

export default HearingLossChart;
